export function salaryRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_SALARY_START":           
        case "FETCH_SALARIES_START":                                 
        case "UPDATE_SALARY_START":                                 
        case "DELETE_SALARY_START":                                 
        case "UPDATE_FETCH_SALARY_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_SALARY_FULFILLED":           
        case "FETCH_SALARIES_FULFILLED":                                 
        case "UPDATE_SALARY_FULFILLED":                                 
        case "DELETE_SALARY_FULFILLED":                                 
        case "UPDATE_FETCH_SALARY_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_SALARY_ERROR":
        case "FETCH_SALARIES_ERROR":
        case "UPDATE_SALARY_ERROR":
        case "DELETE_SALARY_ERROR":
        case "UPDATE_FETCH_SALARY_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}